import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

/** `?q=` carries what was typed into the palette's "Open Coach: …", for the box. */
const search = z.object({ q: z.string().optional().catch(undefined) });

/** The Coach layout draws the conversation (`CoachMain` in coach-page.tsx), so naming it at `/coach/<id>` mounts nothing new. */
function DrawnByLayout(): null {
  return null;
}

/** A new conversation (board 11-coach-home). */
export const Route = createFileRoute('/_app/coach/')({
  validateSearch: search,
  component: DrawnByLayout,
});
